import moment from "moment";
import React from "react";
import submit from "submit-form";
import SvgIcon from "../../../../../parts/SvgIcon";
import { ReportsBackHandler } from "../../../calendar/components/ReportsBackHandler";

export const Header = ({
  listView,
  setListView,
  dateFromState,
  setDateFromState,
  dateToState,
  setDateToState,
  selectedDaysState,
  setSelectedDaysState,
  phasesTemplates,
  locals,
}) => {
  const openAddEventModal = () => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        "modal[type]": "add-event",
        eventFrom:
          selectedDaysState && selectedDaysState.from
            ? moment(selectedDaysState.from).format("YYYYMMDD")
            : null,
        eventTo:
          selectedDaysState && selectedDaysState.to
            ? moment(selectedDaysState.to).format("YYYYMMDD")
            : null,
      },
    });
    setSelectedDaysState([]);
  };

  const { templates } = phasesTemplates;

  const openPhaseTemplateModal = () => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        "modal[type]":
          templates && templates.length
            ? "phase-templates"
            : "add-phase-template",
        eventFrom:
          selectedDaysState && selectedDaysState.from
            ? moment(selectedDaysState.from).format("YYYYMMDD")
            : null,
        eventTo:
          selectedDaysState && selectedDaysState.to
            ? moment(selectedDaysState.to).format("YYYYMMDD")
            : null,
      },
    });
  };

  const goToday = () => {
    setDateFromState(moment.utc().subtract(3, "months").toDate());
    setDateToState(moment.utc().add(9, "months").toDate());
  };

  return (
    <>
      <hgroup className="spaced">
        <h2 className="mobile-hidden">Annual Planner</h2>
        <ReportsBackHandler title={"Annual Planner"} locals={locals} />

        <div className="header-right mobile-hidden">
          <button data-button-type="secondary" onClick={openPhaseTemplateModal}>
            Phase Template
          </button>
          <button data-button-type="primary" onClick={openAddEventModal}>
            <img src="/img/new-icons/add-28.svg" role="left-icon" />
            Add Events
          </button>
          <button data-button-type="secondary" onClick={goToday}>
            Today
          </button>
        </div>
      </hgroup>
      <hgroup className="centered-left">
        <div className="header-left mobile-hidden">
          <button data-button-type="secondary" onClick={goToday}>
            Today
          </button>
          <button
            data-button-type="secondary"
            className="mobile-hidden"
            onClick={() => setListView(!listView)}
          >
            {listView ? "Calendar View" : "List View"}
          </button>
        </div>
        <DateRangeController
          dateFromState={dateFromState}
          setDateFromState={setDateFromState}
          dateToState={dateToState}
          setDateToState={setDateToState}
          keepRange={true}
        />
      </hgroup>
    </>
  );
};

export const DateRangeController = ({
  dateFromState,
  setDateFromState,
  dateToState,
  setDateToState,
  keepRange = false,
}) => {
  const handleHeaderDates = (operation, amount, type) => {
    if (operation === "subtract") {
      setDateFromState(moment(dateFromState).subtract(amount, type));
      keepRange && setDateToState(moment(dateToState).subtract(amount, type));
    } else {
      keepRange && setDateFromState(moment(dateFromState).add(amount, type));
      setDateToState(moment(dateToState).add(amount, type));
    }
  };
  return (
    <div role="month-handler">
      <button
        data-button-type="secondary"
        data-icon-only
        onClick={() => handleHeaderDates("subtract", 1, "year")}
      >
        <SvgIcon src="/img/new-icons/double-arrow-left.svg" />
      </button>
      <div>
        <button
          data-button-type="text-white"
          data-icon-only
          onClick={() => handleHeaderDates("subtract", 1, "month")}
        >
          <SvgIcon src="/img/new-icons/arrow-left.svg" />
        </button>
        <span>
          {moment(dateFromState).format("MMM YYYY")} -{" "}
          {moment(dateToState).subtract(1, "month").format("MMM YYYY")}
        </span>
        <button
          data-button-type="text-white"
          data-icon-only
          onClick={() => handleHeaderDates("add", 1, "month")}
        >
          <SvgIcon src="/img/new-icons/arrow-right.svg" />
        </button>
      </div>
      <button
        data-button-type="secondary"
        data-icon-only
        onClick={() => handleHeaderDates("add", 1, "year")}
      >
        <SvgIcon src="/img/new-icons/double-arrow-right.svg" />
      </button>
    </div>
  );
};
